import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "../../../app/routes";
import { UrlService } from "../../../services";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";
import { usePermission } from "../../../hooks";
import { PermissionDefinitions } from "../../../security";
import { useSelector } from "react-redux";
import { isLocationAdmin } from "../../../app";

export const CalendarsIndexTopbar = (props: any) => {
  const params = useParams();
  const returnUrl = UrlService.getQueryParams("returnUrl");
  const id = params["id"] ?? "";
  const canGetAllProviders = usePermission(PermissionDefinitions.calendar.getAll());
  const locationAdmin = useSelector(isLocationAdmin());

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo((): TopbarMenuItem[] => {
    const items: TopbarMenuItem[] = [
      {
        label: (canGetAllProviders || locationAdmin) ? "Provider" : "My Calendar" ,
        icon: IconDefinitions.home,
        url: routes.calendar.index,
        activeMatch: routes.calendar.index,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
    ];

    if (canGetAllProviders || locationAdmin) {
      items.push(
        {
          label: "Location",
          icon: IconDefinitions.home,
          url: routes.calendar.location,
          activeMatch: routes.calendar.location,
          activeMatchExact: true,
          params: new Map([["id", id]]),
        },
      );
    }

    return items;
  }, [id, canGetAllProviders, locationAdmin]);

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, id, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems}></TopbarSubmenu>;
};

export default CalendarsIndexTopbar;

